import { cn } from "@/lib/utils";
import { BrandMark } from "@/components/common/BrandLogo";

/** Ett sted å bytte «AI» ↔ «KI» for hele presentasjonen. */
export const AI = "KI";

/** Delte byggesteiner for slidene (eyebrow, plassholder, logoer, dato). Portert fra Energi Teknikk-dekket. */

/**
 * Linje-avdekking: hele linjen stiger opp bak en usynlig maske (bare transform).
 * Hver linje er et blokk-element – derfor bryter aldri nettleseren ordene ulikt (Safari/Chrome).
 */
export function Reveal({ children, i = 0, className, delay }) {
  return (
    <span className={cn("pres-reveal", className)} style={{ "--i": i, ...(delay != null ? { "--d0": `${delay}ms` } : null) }}>
      <span>{children}</span>
    </span>
  );
}

export function Eyebrow({ children, className, style }) {
  return <div className={cn("pres-eyebrow", className)} style={style}>{children}</div>;
}

export function Placeholder({ children, block = false }) {
  return (
    <span className={cn("pres-placeholder", block && "block")} title="Plassholder – bytt ut med egen tekst">
      {children}
    </span>
  );
}

/** Kviteberg-logoen (public/brand). Bar-merke i blått + ordmerke. */
export function KvitebergMark({ className }) {
  return (
    <img src="/brand/kviteberg-logo.svg" alt="Kviteberg AS" className={cn("h-6 w-auto sm:h-7", className)} data-testid="pres-kviteberg-mark" draggable={false} />
  );
}

/** Stord Innkvartering: offisielt 3×3-modulmerke + ordmerke (samme komponent som i appen). */
export function StordMark({ className }) {
  return (
    <span className={cn("pres-brand-stord", className)} data-testid="pres-stord-mark">
      <BrandMark className="h-7 w-7 sm:h-8 sm:w-8" color="#0B1220" />
      <span className="pres-brand-stord-text">
        <span className="pres-brand-stord-name">Stord Innkvartering</span>
        <span className="pres-brand-stord-sub">Modulbygg · Stord</span>
      </span>
    </span>
  );
}

export function Brands({ className }) {
  return (
    <div className={cn("pres-brands flex items-center justify-between gap-6", className)} data-testid="pres-brands">
      <KvitebergMark />
      <div className="flex items-center gap-3 text-[12px] text-[var(--pres-muted)]" data-testid="pres-stord-logo">
        <span className="hidden sm:inline">for</span>
        <StordMark />
      </div>
    </div>
  );
}

const MONTHS_NB = ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"];
export const today = () => {
  const d = new Date();
  return `${d.getDate()}. ${MONTHS_NB[d.getMonth()]} ${d.getFullYear()}`;
};

export { RigHero, HERO_MODULE_COUNT } from "./rigHero";
